import type { TranslationKey } from './fr';
import { fleetAr } from '../../features/fleet/locales';
import { peopleAr } from '../../features/people/locales';
import { deploymentAr } from '../../features/deployment/i18n';
import { billingAr } from '../../features/billing/i18n';
import { settingsAr } from '../../features/settings/i18n';
import { satisfactionAr } from '../../features/satisfaction/locales';

export const ar: Record<TranslationKey, string> = {
  'common.error': 'حدث خطأ ما',
  'common.errorDescription': 'تعذّر تحميل البيانات. تحقق من اتصالك ثم أعد المحاولة.',
  'common.retry': 'إعادة المحاولة',
  'common.date': 'التاريخ',

  'ui.close': 'إغلاق',
  'ui.clear': 'مسح',
  'ui.notifications': 'الإشعارات',
  'ui.table.selectAll': 'تحديد الكل',
  'ui.table.selectRow': 'تحديد السطر',
  'ui.table.empty': 'لا توجد نتائج',
  'ui.table.selected': '{count} محدد',
  'ui.table.total': '{count} عنصر',
  'ui.table.pagination': 'ترقيم الصفحات',
  'ui.table.prev': 'الصفحة السابقة',
  'ui.table.next': 'الصفحة التالية',
  'ui.table.page': 'الصفحة {page} من {count}',

  'status.online': 'متصل',
  'status.offline': 'غير متصل',

  'nav.dashboard': 'لوحة التحكم',
  'nav.fleet': 'الأجهزة',
  'nav.people': 'الأشخاص',
  'nav.policies': 'السياسات',
  'nav.audit': 'التدقيق والجلسات',
  'nav.satisfaction': 'الرضا',
  'nav.deployment': 'النشر',
  'nav.billing': 'الفوترة',
  'nav.settings': 'الإعدادات',

  'shell.skipToContent': 'انتقل إلى المحتوى',
  'shell.navigation': 'التنقل الرئيسي',
  'shell.collapse': 'طي القائمة',
  'shell.expand': 'توسيع القائمة',
  'shell.openMenu': 'فتح القائمة',
  'shell.language': 'اللغة',
  'shell.themeDark': 'التبديل إلى السمة الداكنة',
  'shell.themeLight': 'التبديل إلى السمة الفاتحة',
  'shell.userMenu': 'قائمة المستخدم',
  'shell.profile': 'ملفي الشخصي',
  'shell.logout': 'تسجيل الخروج',

  'org.current': 'المؤسسة النشطة',
  'org.switch': 'تغيير المؤسسة',

  'search.placeholder': 'ابحث عن جهاز أو صفحة…',
  'search.results': 'نتائج البحث',
  'search.none': 'لا توجد نتائج',
  'search.page': 'صفحة',

  'forbidden.title': 'الوصول مرفوض',
  'forbidden.description': 'دورك لا يسمح بالوصول إلى هذا القسم. اتصل بمسؤول المؤسسة.',

  'placeholder.eyebrow': 'قريبًا',
  'placeholder.title': 'هذه الشاشة قيد التطوير',
  'placeholder.description': 'الهيكل والتنقل والصلاحيات جاهزة. الشاشات المخطط لها في هذا القسم:',
  'placeholder.planned': 'الشاشات المخطط لها',

  'zone.fleet.title': 'الأجهزة',
  'zone.fleet.description': 'أجهزة المؤسسة وحالة الاتصال والمجموعات والجرد.',
  'zone.fleet.screens': 'قائمة الأجهزة وشجرتها|بطاقة الجهاز|المجموعات والوسوم|الجرد|التنبيهات|الإجراءات (نشر، تحديث، إلغاء)',
  'zone.people.title': 'الأشخاص',
  'zone.people.description': 'الفنيون والأدوار والدعوات وأمان الوصول.',
  'zone.people.screens': 'المستخدمون|الأدوار والصلاحيات|الدعوات|الدخول الموحد|الأجهزة الموثوقة|حظر عناوين IP / الدول',
  'zone.policies.title': 'السياسات',
  'zone.policies.description': 'قواعد الإدارة المطبقة على الوكلاء.',
  'zone.policies.screens': 'قوالب السياسات|التعيين حسب المجموعة / الدور|معاينة الأثر|وضع التجربة',
  'zone.audit.title': 'التدقيق والجلسات',
  'zone.audit.description': 'سجل التدقيق وتاريخ الجلسات والتسجيلات.',
  'zone.audit.screens': 'سجل قابل للتصفية|تفاصيل الجلسة|التسجيلات|تصدير CSV / JSON',
  'zone.deployment.title': 'النشر',
  'zone.deployment.description': 'التسجيل الجماعي وتحديثات الوكلاء.',
  'zone.deployment.screens': 'حزم MSI / PKG|رموز التسجيل|قنوات مستقرة / تجريبية|الإصدارات والتقدم',
  'zone.billing.title': 'الفوترة',
  'zone.billing.description': 'الاشتراك والاستخدام والفواتير.',
  'zone.billing.screens': 'الخطة|الاستخدام|الفواتير|وسيلة الدفع|التجربة المجانية',
  'zone.settings.title': 'الإعدادات',
  'zone.settings.description': 'المؤسسة والعلامة البيضاء والتكاملات ومفاتيح API.',
  'zone.settings.screens': 'المؤسسة والنطاق|العلامة البيضاء|التكاملات|مفاتيح API',

  'login.title': 'تسجيل الدخول',
  'login.subtitle': 'ادخل إلى لوحة إدارة مؤسستك.',
  'login.email': 'البريد الإلكتروني',
  'login.password': 'كلمة المرور',
  'login.submit': 'تسجيل الدخول',
  'login.error.credentials': 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
  'login.error.totp': 'رمز التحقق غير صالح.',
  'login.error.expired': 'انتهت صلاحية التحقق. أعد تسجيل الدخول.',
  'login.error.noOrg': 'هذا الحساب غير مرتبط بأي مؤسسة.',
  'login.error.generic': 'تعذّر تسجيل الدخول حاليًا. حاول مرة أخرى.',
  'login.hero.title': 'أدِر أجهزتك.',
  'login.hero.accent': 'بإحكام كامل.',
  'login.hero.text': 'من يمكنه الاتصال بماذا، ومن أين، وبأي حدود، وبأي تكلفة: كل ذلك يُضبط هنا.',
  'login.hero.p1': 'الأجهزة والمجموعات والحالة في الوقت الحقيقي',
  'login.hero.p2': 'الأدوار والسياسات وسجل التدقيق',
  'login.hero.p3': 'النشر الجماعي والفوترة',
  'login.totp.title': 'التحقق بخطوتين',
  'login.totp.subtitle': 'أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة الخاص بالحساب {email}.',
  'login.totp.code': 'رمز التحقق',
  'login.totp.submit': 'تحقق',
  'login.totp.back': 'رجوع',
  'login.totp.demoHint': 'تجريبي: الرمز هو 123456.',
  'login.demo.title': 'وضع العرض التجريبي',
  'login.demo.hint': 'بيانات محاكاة. كلمة المرور: siraj-demo. انقر للتعبئة.',
  'login.demo.owner': 'مالك',
  'login.demo.supervisor': 'مشرف',
  'login.demo.technician': 'فني',
  'login.demo.billing': 'الفوترة',
  'login.noAccount': 'ليس لديك حساب؟',
  'login.createAccount': 'إنشاء حساب',

  'register.title': 'أنشئ لوحتك',
  'register.subtitle': 'سجّل مؤسستك وكن مالكها.',
  'register.name': 'اسمك',
  'register.email': 'البريد الإلكتروني',
  'register.password': 'كلمة المرور',
  'register.passwordHint': '8 أحرف على الأقل.',
  'register.orgName': 'اسم المؤسسة',
  'register.submit': 'إنشاء الحساب',
  'register.hasAccount': 'لديك حساب بالفعل؟',
  'register.signIn': 'تسجيل الدخول',
  'register.error.emailTaken': 'هذا البريد الإلكتروني مستخدم بالفعل.',
  'register.error.generic': 'تعذّر إنشاء الحساب حاليًا. حاول مرة أخرى.',

  'choosePlan.title': 'اختر عرضًا',
  'choosePlan.subtitle': 'لاستخدام وحدة تحكم {org}، ابدأ التجربة PRO أو اشترك في عرض مدفوع.',
  'choosePlan.trial.title': 'تجربة PRO لمدة 15 يومًا',
  'choosePlan.trial.desc': 'جميع ميزات خطة Pro لمدة 15 يومًا دون التزام. التجربة متاحة مرة واحدة لكل مؤسسة.',
  'choosePlan.trial.used': 'انتهت تجربة هذه المؤسسة. اختر عرضًا مدفوعًا للمتابعة.',
  'choosePlan.trial.cta': 'ابدأ التجربة',
  'choosePlan.trial.done': 'بدأت تجربة PRO لمدة 15 يومًا',
  'choosePlan.plan.pro': 'لفرق الدعم الصغيرة.',
  'choosePlan.plan.team': 'للفرق التي تدير أسطولًا كبيرًا.',
  'choosePlan.plan.enterprise': 'للمؤسسات الكبيرة، بعرض سعر.',
  'choosePlan.paid.cta': 'اشترك',
  'choosePlan.paid.choose': 'الاشتراك في خطة {plan}',
  'choosePlan.paid.done': 'تم تفعيل خطة {plan}',
  'choosePlan.notAllowed': 'يمكن للمالك أو مسؤول الفوترة فقط اختيار عرض. تواصل معه لفتح وحدة التحكم.',
  'choosePlan.freeNote': 'بدون عرض تبقى وحدة التحكم مغلقة. يظل Remote متاحًا بحدود العرض المجاني.',
  'choosePlan.switchOrg': 'تغيير المؤسسة',
  'choosePlan.error': 'تعذّر تنفيذ الإجراء',
  'choosePlan.error.conflict': 'تعذّر تنفيذ الإجراء: التجربة مستخدمة بالفعل أو يوجد اشتراك',
  'invitation.accept.pending': 'جارٍ قبول الدعوة…',
  'invitation.accept.done': 'تم قبول الدعوة. جارٍ التحويل…',
  'invitation.accept.error': 'هذه الدعوة غير صالحة أو منتهية أو موجهة إلى حساب آخر. سجّل الدخول بالبريد الإلكتروني المدعو.',
  'invitation.accept.retry': 'إعادة المحاولة',
  'selectOrg.title': 'اختر مؤسسة',
  'selectOrg.subtitle': 'مرحبًا {name}، أي مؤسسة تريد إدارتها؟',

  'dashboard.greeting': 'مرحبًا {name}',
  'dashboard.subtitle': 'هذه حالة أجهزتك وخدمتك اليوم.',
  'dashboard.kpis': 'المؤشرات الرئيسية',
  'dashboard.devicesOnline': 'الأجهزة المتصلة',
  'dashboard.devicesOnlineHint': '{pct}٪ من الأجهزة',
  'dashboard.sessionsToday': 'جلسات اليوم',
  'dashboard.vsYesterday': 'مقارنة بالأمس',
  'dashboard.activeSessions': 'الجلسات الجارية',
  'dashboard.activeSessionsHint': 'الآن',
  'dashboard.alerts': 'التنبيهات المفتوحة',
  'dashboard.alertsHint': 'منها {count} حرجة',
  'dashboard.activity': 'النشاط خلال 7 أيام',
  'dashboard.activityDesc': 'الجلسات عن بُعد في اليوم',
  'dashboard.activityAria': 'مخطط أعمدة: {total} جلسة خلال آخر 7 أيام',
  'dashboard.sessions': 'الجلسات',
  'dashboard.devicesTouched': 'أجهزة مختلفة',
  'dashboard.usage': 'الاستهلاك',
  'dashboard.usageDesc': 'التراخيص ورصيد الذكاء الاصطناعي للفترة',
  'dashboard.technicians': 'الفنيون',
  'dashboard.aiCredits': 'رصيد الذكاء الاصطناعي',
  'dashboard.devices': 'الأجهزة',
  'dashboard.unlimited': 'غير محدود',
  'dashboard.alertsTitle': 'تنبيهات للمعالجة',
  'dashboard.alertsDesc': 'القرص والذاكرة والأجهزة غير المتصلة والوكلاء القدامى',
  'dashboard.noAlerts': 'لا توجد تنبيهات: كل شيء على ما يرام',
  'dashboard.service': 'حالة الخدمة',
  'dashboard.serviceDesc': 'مكونات سراج',
  'dashboard.updatedAt': 'آخر تحديث في {time}',

  'severity.critical': 'حرج',
  'severity.warning': 'تحذير',
  'severity.info': 'معلومة',
  'alert.offline': 'غير متصل منذ {value} يوم',
  'alert.disk': 'القرص ممتلئ بنسبة {value}٪',
  'alert.ram': 'الذاكرة مستخدمة بنسبة {value}٪',
  'alert.agent_outdated': 'وكيل سراج قديم',
  'alert.policy_denied': 'تم رفض الوصول بسبب سياسة',

  'service.relay': 'المرحّل',
  'service.rendezvous': 'نقطة اللقاء',
  'service.api': 'واجهة API',
  'service.ai': 'مساعد الذكاء الاصطناعي',
  'service.status.operational': 'يعمل',
  'service.status.degraded': 'أداء متدهور',
  'service.status.outage': 'متوقف',
  // >>> zone policies
  'policies.title': 'قوالب السياسات',
  'policies.subtitle': 'قواعد الإدارة المطبّقة على الوكلاء: سقوف الجودة والنقل والخصوصية والأوقات.',
  'policies.new': 'سياسة جديدة',
  'policies.newDesc': 'تُنشأ كمسودة في وضع الاختبار: لا يُطبَّق شيء قبل تأكيدك.',
  'policies.name': 'الاسم',
  'policies.description': 'الوصف',
  'policies.status': 'الحالة',
  'policies.status.active': 'نشطة',
  'policies.status.draft': 'مسودة',
  'policies.version': 'الإصدار',
  'policies.targets': 'الأهداف',
  'policies.targetsAll': 'كل الأجهزة',
  'policies.targetsCount': '{count} هدف',
  'policies.updated': 'آخر تعديل',
  'policies.actions': 'إجراءات',
  'policies.default': 'افتراضية',
  'policies.dryRun': 'وضع الاختبار',
  'policies.empty': 'لا توجد سياسات بعد.',
  'policies.cancel': 'إلغاء',
  'policies.noDefault': 'لا توجد سياسة افتراضية',
  'policies.noDefaultDesc': 'السياسة بلا أهداف تسري على كل الأجهزة. أنشئ سياسة افتراضية متساهلة (بلا قيود) كأساس آمن.',
  'policies.createDefault': 'إنشاء السياسة الافتراضية المتساهلة',
  'policies.defaultName': 'السياسة الافتراضية',
  'policies.defaultDesc': 'متساهلة: تسري على كل الأجهزة التي لا تملك سياسة خاصة.',
  'policies.defaultCreated': 'تم إنشاء السياسة الافتراضية',
  'policies.delete': 'حذف {name}',
  'policies.deleteTitle': 'حذف «{name}»؟',
  'policies.deleteDesc': 'ستعود الوكلاء المعنية إلى السياسة الافتراضية. يبقى سجل الإصدارات في سجل التدقيق.',
  'policies.apply.needName': "اسم السياسة مطلوب لتطبيقها.",
  'policies.apply.noChanges': "لا توجد تغييرات للتطبيق: عدّل السياسة أولا.",
  'policies.deleteDescDefault': "تنطبق هذه السياسة الافتراضية على جميع الوكلاء: حذفها يعيدهم إلى إعدادات النظام.",
  'policies.deleteConfirm': 'حذف',
  'policies.deleted': 'تم حذف السياسة',
  'policies.deleteError': 'تعذّر الحذف',
  'policies.notFound': 'السياسة غير موجودة',
  'policies.backToList': 'كل السياسات',
  'policies.editorSubtitle': 'الإصدار {version} · كل تعديل ينشئ إصدارًا جديدًا',
  'policies.general': 'عام',
  'policies.dryRunLabel': 'وضع الاختبار (تجريبي)',
  'policies.dryRunDesc': 'تسجّل الوكلاء ما كان سيُحظر دون تطبيق أي شيء. موصى به قبل أي قيد.',
  'policies.tabs': 'أقسام السياسة',
  'policies.tab.rules': 'القواعد',
  'policies.tab.assign': 'التعيين والمعاينة',
  'policies.tab.history': 'السجل',
  'policies.tab.delivery': 'التوزيع',
  'policies.saveDraft': 'حفظ المسودة',
  'policies.apply': 'تطبيق…',
  'policies.applyChanges': 'تطبيق التعديلات…',
  'policies.backToDraft': 'إعادة إلى مسودة',
  'policies.resetPermissive': 'العودة إلى القواعد المتساهلة',
  'policies.saved': 'تم حفظ المسودة',
  'policies.applied': 'تم تطبيق السياسة: التوزيع جارٍ',
  'policies.reverted': 'أُعيدت السياسة إلى مسودة',
  'policies.saveError': 'تعذّر الحفظ. أعد المحاولة.',
  'error.featureUnavailable': 'هذه الميزة غير متضمنة في خطتك الحالية. قم بالترقية لاستخدامها.',
  'error.quotaExceeded': 'لقد بلغت حدّ خطتك. قم بالترقية لرفعه.',
  'error.upgradeLink': 'عرض الخطط',
  'error.invalidResponse': 'استجابة غير متوقعة من الخادم. أعد المحاولة بعد قليل.',
  'policies.forbidden': 'ليست لديك صلاحية تعديل السياسات.',
  'policies.rules.emptyUnlimited': 'فارغ = بلا حد',
  'policies.rules.transfers': 'النقل والحافظة',
  'policies.rules.transfersDesc': 'أنواع الملفات المحظورة والحجم الأقصى واتجاه النسخ واللصق.',
  'policies.rules.privacy': 'الخصوصية والتحكم',
  'policies.rules.privacyDesc': 'شاشة الخصوصية والتسجيل وموافقة المسؤول.',
  'policies.rules.windows': 'نوافذ أوقات الوصول',
  'policies.rules.windowsDesc': 'تسري على أهداف السياسة (فنيون وأدوار ومجموعات). خارج النافذة يُرفض الوصول.',
  'policies.rule.blockedFileTypes': 'أنواع الملفات المحظورة',
  'policies.rule.blockedFileTypesHint': 'امتدادات مفصولة بفواصل',
  'policies.rule.maxTransferMb': 'أقصى حجم للنقل الواحد (م.ب)',
  'policies.rule.clipboard': 'الحافظة',
  'policies.rule.privacyScreen': 'شاشة الخصوصية',
  'policies.rule.privacyScreenDesc': 'تحجب شاشة الجهاز أثناء الجلسة.',
  'policies.rule.recordingRequired': 'التسجيل إلزامي',
  'policies.rule.recordingRequiredDesc': 'تُسجَّل كل جلسة (مع الاحتفاظ والتشفير).',
  'policies.rule.requireApproval': 'موافقة المسؤول',
  'policies.rule.requireApprovalDesc': 'ينتظر الاتصال الحساس موافقة المسؤول.',
  'policies.rule.approverRole': 'دور الموافق',
  'policies.rule.approverNone': 'اختر دورًا',
  'policies.rule.approverRoleId': 'دور الموافق',
  'policies.rule.accessWindows': 'نوافذ الوقت',
  'policies.rule.targets': 'التعيين',
  'policies.rule.enabled': 'الحالة',
  'policies.rule.dryRun': 'وضع الاختبار',
  'policies.clipboard.both': 'في الاتجاهين',
  'policies.clipboard.to_host': 'إلى الجهاز فقط',
  'policies.clipboard.from_host': 'من الجهاز فقط',
  'policies.clipboard.none': 'محظور',
  'policies.window.add': 'إضافة نافذة',
  'policies.window.none': 'لا توجد نوافذ: الوصول مسموح في أي وقت.',
  'policies.window.days': 'الأيام',
  'policies.window.start': 'البداية',
  'policies.window.end': 'النهاية',
  'policies.window.remove': 'حذف النافذة',
  'policies.day.0': 'الأحد',
  'policies.day.1': 'الاثنين',
  'policies.day.2': 'الثلاثاء',
  'policies.day.3': 'الأربعاء',
  'policies.day.4': 'الخميس',
  'policies.day.5': 'الجمعة',
  'policies.day.6': 'السبت',
  'policies.assign.title': 'التعيين',
  'policies.assign.desc': 'حسب المجموعة أو الدور أو الفني أو الجهاز. بلا أي هدف تسري السياسة على كل الأجهزة.',
  'policies.assign.groups': 'مجموعات الأجهزة',
  'policies.assign.noGroups': 'لا توجد مجموعات',
  'policies.assign.roles': 'الأدوار',
  'policies.assign.members': 'الفنيون',
  'policies.assign.devices': 'الأجهزة',
  'policies.assign.searchMembers': 'ابحث عن فني',
  'policies.assign.searchDevices': 'ابحث عن جهاز',
  'policies.assign.selectedDevices': 'الأجهزة المحددة',
  'policies.preview.title': 'معاينة الأثر',
  'policies.preview.desc': 'تقدّر الأجهزة والمستخدمين المتأثرين وتكشف التعارضات قبل أي تطبيق.',
  'policies.preview.run': 'احسب المعاينة',
  'policies.preview.devices': 'أجهزة متأثرة',
  'policies.preview.members': 'مستخدمون متأثرون',
  'policies.preview.conflicts': 'تعارضات',
  'policies.preview.conflict': 'تتداخل مع «{name}» على {count} جهاز: تسود القاعدة الأكثر تقييدًا.',
  'policies.preview.dryRunNote': 'وضع الاختبار: لا حظر فعلي، الوكلاء تسجّل فقط.',
  'policies.preview.error': 'المعاينة غير متاحة. يمكنك إعادة المحاولة.',
  'policies.warn.access_windows': 'ستمنع نوافذ الوقت الوصول خارج الفترات المحددة.',
  'policies.warn.no_approver': 'لا يملك أي عضو دور الموافق: ستبقى الاتصالات الحساسة محظورة.',
  'policies.warn.clipboard_none': 'الحافظة محظورة في الاتجاهين.',
  'policies.warn.no_target': 'لا يستهدف هذا التعيين أي جهاز.',
  'policies.risk.title': 'مخاطر الإقصاء من الوصول',
  'policies.risk.windows_invalid': 'نافذة وقت تنتهي قبل بدايتها أو عندها.',
  'policies.risk.windows_no_days': 'نافذة وقت بلا أيام: لا تسمح بالوصول أبدًا.',
  'policies.risk.windows_narrow': 'تغطي النوافذ أقل من 20 ساعة أسبوعيًا: سيكون الوصول محدودًا جدًا.',
  'policies.risk.approval_no_approver': 'الموافقة مطلوبة بلا دور موافق: لن يتمكن أحد من الاعتماد.',
  'policies.risk.global_restrictive': 'هذه السياسة المقيِّدة تستهدف كل الأجهزة بمن فيهم المسؤولون.',
  'policies.risk.ack': 'أدرك خطر الإقصاء وأريد التطبيق مع ذلك.',
  'policies.apply.title': 'تطبيق السياسة؟',
  'policies.apply.titleDryRun': 'التفعيل في وضع الاختبار؟',
  'policies.apply.desc': 'تحقق من الأثر المتوقع. سيُدفع الإصدار الجديد إلى الوكلاء المتصلين.',
  'policies.apply.confirm': 'طبّق الآن',
  'policies.apply.confirmDryRun': 'فعّل في وضع الاختبار',
  'policies.history.title': 'سجل الإصدارات',
  'policies.history.desc': 'يُحتفظ بكل تعديل. العودة إلى إصدار سابق تنشئ إصدارًا جديدًا.',
  'policies.history.empty': 'لا توجد إصدارات',
  'policies.history.current': 'الإصدار الحالي',
  'policies.history.changed': 'تغيّر:',
  'policies.history.rollbackOf': 'عودة إلى الإصدار {version}',
  'policies.history.rollback': 'العودة إلى الإصدار {version}',
  'policies.history.rollbackTitle': 'العودة إلى الإصدار {version}؟',
  'policies.history.rollbackDesc': 'ستُستعاد قواعد وتعيين الإصدار {version} كإصدار جديد {next} يُدفع إلى الوكلاء.',
  'policies.history.rollbackConfirm': 'عودة',
  'policies.history.rolledBack': 'تمت استعادة الإصدار {version}',
  'policies.history.rollbackError': 'تعذّرت العودة',
  'policies.delivery.title': 'التوزيع على الوكلاء',
  'policies.delivery.desc': 'إقرار كل وكيل باستلام الإصدار الحالي.',
  'policies.delivery.dryRunDesc': 'وضع الاختبار: تُقِرّ الوكلاء بالاستلام ولا تحظر شيئًا.',
  'policies.delivery.none': 'لا يوجد توزيع',
  'policies.delivery.noneDesc': 'لا تُدفع المسودة إلى أي وكيل. طبّق السياسة لنشرها.',
  'policies.delivery.progress': 'أقرّ {done} / {total} وكيل بالاستلام ({pct}٪)',
  'policies.delivery.device': 'الجهاز',
  'policies.delivery.status': 'الحالة',
  'policies.delivery.ackedAt': 'وقت الإقرار',
  'policies.delivery.acknowledged': 'تم الاستلام',
  'policies.delivery.pending': 'قيد الانتظار',
  'policies.delivery.offline': 'غير متصل',
  'policies.delivery.failed': 'فشل',
  // <<< zone policies
  // >>> zone fleet
  ...fleetAr,
  // <<< zone fleet
  // >>> zone people
  ...peopleAr,
  // <<< zone people
  // >>> zone deployment
  ...deploymentAr,
  // <<< zone deployment
  // >>> zone billing
  ...billingAr,
  // <<< zone billing
  // >>> zone audit
  'audit.title': 'التدقيق والجلسات',
  'audit.subtitle': 'سجل تدقيق موقّع وتاريخ الجلسات والتسجيلات وتقارير الامتثال.',
  'audit.tabs': 'أقسام التدقيق والجلسات',
  'audit.tab.journal': 'سجل التدقيق',
  'audit.tab.sessions': 'الجلسات',
  'audit.tab.compliance': 'الامتثال',
  'audit.cancel': 'إلغاء',
  'audit.journal': 'سجل التدقيق',
  'audit.search': 'بحث (المنفّذ، الإجراء، الهدف، IP)',
  'audit.count': '{count} حدث',
  'audit.loading': 'جارٍ التحميل…',
  'audit.empty': 'لا يوجد حدث يطابق المرشحات.',
  'audit.filter.action': 'الإجراء',
  'audit.filter.actor': 'المنفّذ',
  'audit.filter.outcome': 'النتيجة',
  'audit.filter.device': 'الجهاز',
  'audit.filter.devicePlaceholder': 'اسم الجهاز',
  'audit.filter.signature': 'التوقيع',
  'audit.filter.from': 'من',
  'audit.filter.to': 'إلى',
  'audit.filter.all': 'الكل',
  'audit.filter.reset': 'إعادة ضبط المرشحات',
  'audit.col.time': 'الوقت',
  'audit.col.actor': 'المنفّذ',
  'audit.col.action': 'الإجراء',
  'audit.col.target': 'الهدف',
  'audit.col.outcome': 'النتيجة',
  'audit.col.signature': 'التوقيع',
  'audit.outcome.success': 'نجاح',
  'audit.outcome.failure': 'فشل',
  'audit.outcome.denied': 'مرفوض',
  'audit.actorType.member': 'عضو',
  'audit.actorType.device': 'جهاز',
  'audit.actorType.system': 'نظام',
  'audit.actorType.api': 'واجهة API',
  'audit.signature.valid': 'التوقيع موثَّق',
  'audit.signature.invalid': 'التوقيع غير صالح',
  'audit.signature.validDesc': 'سلسلة التجزئة سليمة: لم يُعدَّل الحدث منذ تسجيله.',
  'audit.signature.invalidDesc': 'سلسلة التجزئة غير متطابقة: ربما عُدِّل الحدث أو فُقد. تواصل مع دعم سراج واحتفظ بنسخة من JSON.',
  'audit.event.title': 'تفاصيل الحدث',
  'audit.event.open': 'فتح الحدث {action}',
  'audit.event.origin': 'المصدر',
  'audit.event.json': 'الحدث الخام (JSON)',
  'audit.event.copy': 'نسخ JSON',
  'audit.event.copied': 'تم نسخ JSON',
  'audit.event.copyError': 'تعذّر النسخ',
  'audit.export.button': 'تصدير',
  'audit.export.csv': 'تصدير بصيغة CSV',
  'audit.export.json': 'تصدير بصيغة JSON',
  'audit.export.done': 'تم تنزيل التصدير: {filename}',
  'audit.export.error': 'تعذّر التصدير',
  'audit.session.title': 'تفاصيل الجلسة',
  'audit.session.search': 'بحث (الجهاز، الفني، التذكرة)',
  'audit.session.count': '{count} جلسة',
  'audit.session.empty': 'لا توجد جلسة تطابق المرشحات.',
  'audit.session.open': 'فتح الجلسة على {device}',
  'audit.session.start': 'البداية',
  'audit.session.end': 'النهاية',
  'audit.session.ongoing': 'جارية',
  'audit.session.duration': 'المدة',
  'audit.session.technician': 'الفني',
  'audit.session.device': 'الجهاز',
  'audit.session.deletedDevice': 'جهاز محذوف',
  'audit.session.modeCol': 'النمط',
  'audit.session.statusCol': 'الحالة',
  'audit.session.recording': 'التسجيل',
  'audit.session.recorded': 'مسجّلة',
  'audit.session.ticketCol': 'التذكرة',
  'audit.session.actions': 'الإجراءات المنفّذة',
  'audit.session.transferred': 'البيانات المنقولة',
  'audit.session.mode.attended': 'بحضور المستخدم',
  'audit.session.mode.unattended': 'بدون مراقبة',
  'audit.session.status.active': 'جارية',
  'audit.session.status.ended': 'منتهية',
  'audit.session.status.failed': 'فاشلة',
  'audit.session.participants': 'المشاركون',
  'audit.session.role.technician': 'فني',
  'audit.session.role.client': 'عميل',
  'audit.session.role.observer': 'مراقب',
  'audit.session.summary': 'ملخص الذكاء الاصطناعي',
  'audit.session.noSummary': 'لا يوجد ملخص.',
  'audit.session.rating': 'تقييم العميل',
  'audit.session.ratingValue': '{value} من 5',
  'audit.session.noRating': 'لا يوجد تقييم من العميل.',
  'audit.session.clientComment': 'تعليق العميل',
  'audit.session.ticket': 'تقرير التذكرة',
  'audit.session.ticketDownload': 'تنزيل التقرير (JSON)',
  'audit.session.noTicket': 'لا توجد تذكرة مرتبطة بهذه الجلسة.',
  'audit.rec.title': 'التسجيل',
  'audit.rec.none': 'لم تُسجَّل هذه الجلسة.',
  'audit.rec.consent': 'موافقة العميل',
  'audit.rec.consent.granted': 'ممنوحة',
  'audit.rec.consent.pending': 'قيد الانتظار',
  'audit.rec.consent.denied': 'مرفوضة',
  'audit.rec.size': 'الحجم',
  'audit.rec.sizeValue': '{size} م.ب · {duration}',
  'audit.rec.encryption': 'التشفير',
  'audit.rec.encrypted': 'مشفّر أثناء التخزين',
  'audit.rec.notEncrypted': 'غير مشفّر',
  'audit.rec.retention': 'الاحتفاظ',
  'audit.rec.retentionUntil': 'حتى {date} (متبقٍّ {days} يوم)',
  'audit.rec.purged': 'حُذف في {date} (انتهى الاحتفاظ)',
  'audit.rec.purgedNote': 'حُذف التسجيل عند انتهاء مدة الاحتفاظ.',
  'audit.rec.pendingNote': 'التشغيل مقفل: لم يوافق العميل بعد على المراجعة.',
  'audit.rec.deniedNote': 'التشغيل غير ممكن: رفض العميل المراجعة.',
  'audit.rec.play': 'تشغيل التسجيل',
  'audit.rec.noPermission': 'يلزم إذن «التسجيلات».',
  'audit.rec.playTitle': 'تشغيل التسجيل',
  'audit.rec.playDesc': 'يُسجَّل التشغيل في سجل التدقيق مع السبب الذي تذكره.',
  'audit.rec.reason': 'سبب المراجعة',
  'audit.rec.reasonHint': '5 أحرف على الأقل (مثل نزاع أو تذكرة أو تدريب).',
  'audit.rec.playConfirm': 'تشغيل',
  'audit.rec.consentRequired': 'لم يوافق العميل على المراجعة.',
  'audit.rec.accessError': 'تعذّر الوصول إلى التسجيل.',
  'audit.rec.player': 'مشغّل التسجيل',
  'audit.rec.pause': 'إيقاف مؤقت',
  'audit.rec.resume': 'تشغيل',
  'audit.rec.seek': 'موضع التشغيل',
  'audit.rec.expires': 'وصول مؤقت صالح حتى {time}',
  'audit.compliance.period': 'الفترة',
  'audit.compliance.lastDays': 'آخر {days} يومًا',
  'audit.compliance.download': 'تنزيل التقرير',
  'audit.compliance.exportEvents': 'تصدير الأحداث',
  'audit.compliance.access': 'مؤشرات الوصول',
  'audit.compliance.events': 'الأحداث المدقَّقة',
  'audit.compliance.sessionsHint': '{count} جلسة في الفترة',
  'audit.compliance.denied': 'وصول مرفوض',
  'audit.compliance.deniedHint': 'محظورة بسياسة أو دور',
  'audit.compliance.failures': 'حالات الفشل',
  'audit.compliance.failedLogins': 'منها {count} محاولة دخول فاشلة',
  'audit.compliance.invalid': 'توقيعات غير صالحة',
  'audit.compliance.invalidHint': 'سلامة سلسلة التجزئة',
  'audit.compliance.invalidAlert': '{count} حدث بتوقيع غير صالح في الفترة: يلزم الفحص.',
  'audit.compliance.review': 'عرض الأحداث',
  'audit.compliance.retention': 'الاحتفاظ بالبيانات',
  'audit.compliance.retentionDesc': 'مدد الاحتفاظ المطبّقة على مؤسستك (قابلة للتعديل في الإعدادات).',
  'audit.compliance.auditRetention': 'سجل التدقيق',
  'audit.compliance.recRetention': 'تسجيلات الجلسات',
  'audit.compliance.days': '{days} يومًا',
  'audit.compliance.integrity': 'السلامة',
  'audit.compliance.integrityDesc': 'كل حدث موقّع ومتسلسل؛ يُكشف أي تلاعب.',
  // <<< zone audit

  // Zone Paramètres
  ...settingsAr,
  ...satisfactionAr,
};
